/* ============================================================
   PM CART v3 — drawer + cart page controller
   ============================================================ */
(function () {
  'use strict';

  var DRAWER_SECTION = 'cart-drawer-contents';
  var PAGE_SECTION = 'cart-main';
  var SWAP_IDS = ['cart-qualifications', 'cart-items', 'cart-footer-summary', 'cart-samples'];

  var symbol = (document.body.getAttribute('data-currency-symbol') || '€');

  function money(cents) {
    var n = (parseFloat(cents) || 0) / 100;
    var s = n.toFixed(2).replace(/\.00$/, '');
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return symbol + s;
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function fetchSection(section) {
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/';
    return fetch(url + '?section_id=' + section, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); });
  }

  function swapFrom(html, container) {
    if (!container) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    SWAP_IDS.forEach(function (id) {
      var fresh = doc.getElementById(id);
      /* Fall back to a document-wide lookup so blocks outside `container`
         (e.g. the complimentary-testers section in its own .pmc-cart) refresh too. */
      var live = container.querySelector('#' + id) || document.getElementById(id);
      if (fresh && live) live.replaceWith(fresh);
    });
    var countEl = doc.querySelector('[data-cart-count]');
    return countEl ? parseInt(countEl.getAttribute('data-cart-count'), 10) : null;
  }

  function setEmptyState(scope, count) {
    if (!scope) return;
    var empty = scope.querySelector('#cart-empty');
    var hideWhenEmpty = scope.querySelectorAll('.drawer-footer, .pmc-summary, .pmc-upsell, .pmc-trust, .pmc-promo, .pmc-routine, .pmc-recent');
    if (count === 0) {
      if (empty) empty.style.display = 'block';
      hideWhenEmpty.forEach(function (el) { el.style.display = 'none'; });
    } else {
      if (empty) empty.style.display = 'none';
      hideWhenEmpty.forEach(function (el) { el.style.removeProperty('display'); });
    }
  }

  function scrim(scope, on) {
    if (!scope) return;
    var s = scope.querySelector('#cart-loading-scrim');
    if (s) s.classList.toggle('active', !!on);
  }

  function refreshDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return Promise.resolve();
    scrim(drawer, true);
    return fetchSection(DRAWER_SECTION).then(function (html) {
      var count = swapFrom(html, drawer);
      var badge = drawer.querySelector('[data-cart-drawer-count]');
      if (badge && count != null) badge.textContent = count;
      setEmptyState(drawer, count);
      scrim(drawer, false);
    }).catch(function () { scrim(drawer, false); });
  }

  function refreshPage() {
    var page = document.querySelector('.pmc-cart');
    if (!page) return Promise.resolve();
    scrim(page, true);
    return fetchSection(PAGE_SECTION).then(function (html) {
      var count = swapFrom(html, page);
      var ct = page.querySelector('[data-cart-page-count]');
      if (ct && count != null) ct.textContent = count + (count === 1 ? ' unit' : ' units');
      setEmptyState(page, count);
      document.querySelectorAll('.pmc-routine, .pmc-recent').forEach(function (el) {
        if (count === 0) el.style.display = 'none'; else el.style.removeProperty('display');
      });
      scrim(page, false);
      enforceTesters();
    }).catch(function () { scrim(page, false); });
  }

  function refreshActive() {
    if (document.querySelector('.pmc-cart')) return refreshPage();
    return refreshDrawer();
  }

  /* Complimentary testers are earned per threshold spent (data-eligible-samples).
     If the paid total drops below the threshold — items removed/reduced — a tester
     already in the bag is no longer earned. Strip any excess so a free sample can't
     ride along under the threshold. Runs on load + after every cart refresh; converges. */
  function enforceTesters() {
    var box = document.getElementById('cart-samples');
    if (!box) return;
    var eligible = parseInt(box.getAttribute('data-eligible-samples') || '0', 10);
    var testerLines = document.querySelectorAll('.pmc-cart .pmc-line.sample-item, #cart-drawer .pmc-line.sample-item');
    var excess = testerLines.length - eligible;
    if (excess <= 0) return;
    var updates = {};
    for (var i = 0; i < excess && i < testerLines.length; i++) {
      var key = testerLines[testerLines.length - 1 - i].getAttribute('data-line-item-key');
      if (key) updates[key] = 0;
    }
    if (Object.keys(updates).length) changeLines(updates, document.querySelector('.pmc-cart') || document.getElementById('cart-drawer'));
  }

  function changeLine(key, qty, scope) {
    scrim(scope, true);
    return postJSON('/cart/change.js', { id: key, quantity: qty })
      .then(function () { return refreshActive(); })
      .catch(function () { scrim(scope, false); });
  }

  function addVariant(variantId, qty) {
    return postJSON('/cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] })
      .then(function () { return refreshActive(); });
  }

  /* Update several lines in one request (keyed by line-item key). */
  function changeLines(updates, scope) {
    scrim(scope, true);
    return postJSON('/cart/update.js', { updates: updates })
      .then(function () { return refreshActive(); })
      .catch(function () { scrim(scope, false); });
  }

  /* A free gift line carries data-gwp-parent-id = its parent's variant id.
     Given a parent line element, return the linked gift line's key (or null). */
  function linkedGiftKey(lineEl) {
    var vid = lineEl && lineEl.getAttribute('data-variant-id');
    if (!vid) return null;
    var g = document.querySelector('.pmc-line.gwp-item[data-gwp-parent-id="' + vid + '"]');
    return g ? g.getAttribute('data-line-item-key') : null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var dec = e.target.closest('.pmc-qty-dec');
    var inc = e.target.closest('.pmc-qty-inc');
    var rem = e.target.closest('.pmc-line .pmc-remove');
    var addBtn = e.target.closest('[data-pmc-add]');
    var addAll = e.target.closest('[data-pmc-add-all]');
    var sampleBtn = e.target.closest('.cart-sample .add-to-cart');

    if (dec || inc) {
      var item = e.target.closest('.pmc-line');
      if (!item) return;
      var input = item.querySelector('.pmc-qty-input');
      var step = parseInt(input && input.getAttribute('step'), 10) || 1;
      var cur = parseInt(input && input.value, 10) || 0;
      var next = inc ? cur + step : Math.max(0, cur - step);
      if (next === cur) return;
      /* B2B: the input value + step are already in UNITS (step = the product's pack multiple),
         so send `next` straight through — no cases conversion. */
      var scope = item.closest('.pmc-cart') || item.closest('#cart-drawer');
      /* Linked free gifts aren't touched here: the free-gift section's cart sync
         sets the gift to the product's GWP ratio (every X units = Y gifts) after this change. */
      changeLine(item.getAttribute('data-line-item-key'), next, scope);
      return;
    }

    if (rem) {
      e.preventDefault();
      var ri = rem.closest('.pmc-line');
      if (!ri) return;
      var rscope = ri.closest('.pmc-cart') || ri.closest('#cart-drawer');
      /* Removing a parent line also removes its linked free gift (no orphan gift). */
      var rGiftKey = linkedGiftKey(ri);
      if (rGiftKey) {
        var rupd = {};
        rupd[ri.getAttribute('data-line-item-key')] = 0;
        rupd[rGiftKey] = 0;
        changeLines(rupd, rscope);
      } else {
        changeLine(ri.getAttribute('data-line-item-key'), 0, rscope);
      }
      return;
    }

    /* Complimentary tester — add the selected sample variant (qty 1), then refresh. */
    if (sampleBtn) {
      e.preventDefault();
      var srow = sampleBtn.closest('.cart-sample');
      var svid = srow && srow.getAttribute('data-first-variant-id');
      if (!svid || sampleBtn.disabled) return;
      var slabel = sampleBtn.textContent;
      sampleBtn.disabled = true; sampleBtn.textContent = 'Adding…';
      scrim(document.querySelector('.pmc-cart'), true);
      addVariant(svid, 1).catch(function () {
        sampleBtn.textContent = 'Try again';
        setTimeout(function () { sampleBtn.disabled = false; sampleBtn.textContent = slabel; }, 1400);
      });
      return;
    }

    if (addBtn) {
      e.preventDefault();
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid || addBtn.disabled) return;
      var label = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      addVariant(vid, 1)
        .then(function () { addBtn.textContent = 'Added ✓'; })
        .catch(function () { addBtn.textContent = 'Try again'; })
        .finally(function () {
          setTimeout(function () { addBtn.disabled = false; addBtn.textContent = label; }, 1400);
        });
      return;
    }

    if (addAll) {
      e.preventDefault();
      var ids = (addAll.getAttribute('data-pmc-add-all') || '').split(',').filter(Boolean);
      if (!ids.length || addAll.disabled) return;
      var lbl = addAll.textContent;
      addAll.disabled = true; addAll.textContent = 'Adding…';
      postJSON('/cart/add.js', { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
        .then(function () { return refreshActive(); })
        .then(function () { addAll.textContent = 'Added ✓'; })
        .catch(function () { addAll.textContent = 'Try again'; })
        .finally(function () {
          setTimeout(function () { addAll.disabled = false; addAll.textContent = lbl; }, 1400);
        });
    }
  });

  function bridgeCartRefresh() {
    if (typeof window.cart === 'undefined' && typeof cart === 'undefined') return false;
    try {
      var c = (typeof cart !== 'undefined') ? cart : window.cart;
      if (c && !c.__pmcBridged) { c.refresh = refreshDrawer; c.__pmcBridged = true; }
      return true;
    } catch (e) { return false; }
  }
  if (!bridgeCartRefresh()) {
    var tries = 0, iv = setInterval(function () { if (bridgeCartRefresh() || ++tries > 40) clearInterval(iv); }, 100);
  }

  (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      document.body.classList.toggle('pmc-cart-open', drawer.classList.contains('active'));
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  })();

  function recCardImg(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return img ? '<span class="ip"><img src="' + img + '" alt="" loading="lazy"></span>' : '<span class="ip"></span>';
  }
  function fetchRecs(pid, intents, limit) {
    intents = intents.slice();
    function tryNext() {
      if (!pid || !intents.length) return Promise.resolve([]);
      var intent = intents.shift();
      return fetch('/recommendations/products.json?product_id=' + pid + '&intent=' + intent + '&limit=' + limit, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { var ps = (d && d.products) || []; return ps.length ? ps : tryNext(); })
        .catch(function () { return tryNext(); });
    }
    return tryNext();
  }

  var RV_KEY = 'pmc_recently_viewed';
  function getRV() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; } }
  function recordPDP() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];
    var list = getRV().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8))); } catch (e) {}
  }
  recordPDP();

  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escText(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  /* Canonical .product-card markup from sections/pnm-collection-grid.liquid
     so the recently-viewed cards on the cart page inherit the same visual
     treatment as every other product card on the site. */
  function renderRecent(products, row, wrap) {
    var html = products.filter(Boolean).slice(0, 4).map(function (p) {
      var img = p.featured_image
        ? '<img class="img-default" src="' + escAttr(p.featured_image) + '" alt="' + escAttr(p.title) + '" loading="lazy">'
        : '<div class="bottle"></div>';
      var hover = (p.images && p.images[1])
        ? '<img class="img-hover" src="' + escAttr(p.images[1]) + '" alt="" loading="lazy">'
        : '';
      var price = money(p.price);
      if (p.compare_at_price && p.compare_at_price > p.price) {
        price += ' <span class="was">' + money(p.compare_at_price) + '</span>';
      }
      return '<a class="product-card" href="' + escAttr(p.url) + '">' +
        '<div class="media">' + img + hover + '</div>' +
        '<h3 class="name">' + escText(p.title) + '</h3>' +
        '<div class="meta"><span class="price">' + price + '</span></div>' +
      '</a>';
    }).join('');
    if (!html) { wrap.hidden = true; return; }
    row.innerHTML = html;
    wrap.hidden = false;
  }
  function recentFallback(wrap, row) {
    var fid = wrap.getAttribute('data-recent-fallback-id');
    fetchRecs(fid, ['related', 'complementary'], 4).then(function (products) {
      if (!products.length) { wrap.hidden = true; return; }
      renderRecent(products, row, wrap);
    });
  }
  function hydrateRecentlyViewed() {
    var wrap = document.querySelector('.pmc-recent');
    if (!wrap) return;
    var row = wrap.querySelector('.row4');
    if (!row) return;
    var cartHandles = (wrap.getAttribute('data-cart-handles') || '').split(',').filter(Boolean);
    var handles = getRV().filter(function (h) { return cartHandles.indexOf(h) === -1; }).slice(0, 4);
    if (!handles.length) { recentFallback(wrap, row); return; }
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);
      if (valid.length) renderRecent(valid, row, wrap);
      else recentFallback(wrap, row);
    });
  }

  function hydrateRoutine() {
    var wrap = document.querySelector('.pmc-routine');
    if (!wrap) return;
    var pid = wrap.getAttribute('data-routine-product-id');
    var row = wrap.querySelector('.row3');
    if (!pid || !row) { wrap.hidden = true; return; }
    fetchRecs(pid, ['complementary', 'related'], 3).then(function (products) {
      if (!products.length) { wrap.hidden = true; return; }
      var bundle = [];
      row.innerHTML = products.map(function (p) {
        var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
        if (variant && variant.available !== false) bundle.push({ id: variant.id, price: p.price });
        var price = '<b>' + money(p.price) + '</b>';
        if (p.compare_at_price && p.compare_at_price > p.price) {
          price += ' <span class="was">' + money(p.compare_at_price) + '</span>';
        }
        var addBtn = variant
          ? '<button class="add" data-pmc-add data-variant-id="' + variant.id + '">+ Add to bag</button>'
          : '<button class="add" disabled>Sold out</button>';
        return '<div class="pmc-ritem">' + recCardImg(p) +
          '<h5>' + p.title + '</h5>' +
          '<p class="pr">' + price + '</p>' + addBtn + '</div>';
      }).join('');
      var cta = wrap.querySelector('.cta');
      if (cta && bundle.length > 1) {
        var total = bundle.reduce(function (s, b) { return s + (b.price || 0); }, 0);
        var ids = bundle.map(function (b) { return b.id; }).join(',');
        cta.innerHTML = '<span class="save-line">Add all ' + bundle.length + ' to your routine · <b>' + money(total) + '</b></span>' +
          '<button class="add-all" data-pmc-add-all="' + ids + '">Add routine</button>';
        cta.hidden = false;
      } else if (cta) { cta.hidden = true; }
      wrap.hidden = false;
    });
  }

  function hydrateModules() { hydrateRoutine(); hydrateRecentlyViewed(); enforceTesters(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateModules);
  } else {
    hydrateModules();
  }
})();
